import { render } from "./Needle.vue?vue&type=template&id=4fba40c6"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Needle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fba40c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fba40c6', __exports__)) {
    api.reload('4fba40c6', __exports__)
  }
  
  module.hot.accept("./Needle.vue?vue&type=template&id=4fba40c6", () => {
    api.rerender('4fba40c6', render)
  })

}


export default __exports__